'use client'
import { useCurrentRef } from '@app/hooks'
import { Box, Typography, useTheme } from '@mui/material'
import React, { ReactNode, useEffect, useState } from 'react'

interface GroupBoxProps {
	label?: string
	children?: ReactNode
}
export const GroupBox = React.forwardRef(function GroupBox(props: GroupBoxProps, ref: any) {
	const { label: caption, children } = props
	const theme = useTheme()

	return (
		<Box
			m="0.5em" // The margin allows the border to be away from the edge of the component so that we can center the label on the line
			pb="0.5em"
			px="0.5em"
			pt="0.7em"
			sx={{
				position: 'relative',
				borderWidth: 1,
				borderColor: 'divider',
				borderRadius: theme.shape.borderRadius,
				borderStyle: 'solid'
			}}
		>
			<Caption label={caption}></Caption>
			{children}
		</Box>
	)
})
interface CaptionProps {
	label?: string
}
const Caption = React.forwardRef(function Caption(props: CaptionProps, passedRef: any) {
	const { label } = props
	const [ref, setRef] = useCurrentRef<HTMLElement>(passedRef)
	const [minWidth, setMinWidth] = useState(0)

	useEffect(() => {
		if (!ref) return
		setMinWidth(ref.offsetWidth)
	}, [ref])

	if (!label) return

	return (
		<Box minWidth={minWidth}>
			<Typography
				ref={setRef}
				fontSize="inherit"
				sx={{
					whiteSpace: 'pre',
					position: 'absolute',
					left: '0.25em', // the left and top settings work with a padding and margin of 0.5em
					top: '-0.8em',
					zIndex: 'tooltip',
					bgcolor: 'background.paper'
				}}
			>
				{' ' + label + ' '}
			</Typography>
		</Box>
	)
})
